import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type SwipeDirection = 'left' | 'right' | null;

@Injectable({ providedIn: 'root' })
export class SwipeNavigationService {
  
  private direction$ = new BehaviorSubject<SwipeDirection>(null);
  
  readonly swipe$ = this.direction$.asObservable();

  setSwipe(direction: SwipeDirection) {
    console.log('SwipeNavigationService direction ', direction)
    this.direction$.next(direction);
  }

  reset() {
    this.direction$.next(null);
  }
}